import './PublicSite.css';

export default function HowToHelp() {
  return (
    <div className="page how-to-help-page">
      <section className="page-hero">
        <div className="container">
          <h1>How You Can Help</h1>
          <p className="lead">Join us in proving that compassion scales</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="help-grid">
            <div className="help-card">
              <div className="help-icon">💝</div>
              <h3>Become a Sponsor</h3>
              <p>
                Monthly sponsors are the backbone of our operations. Your recurring donation provides:
              </p>
              <ul>
                <li>Food and medical care for 100+ animals</li>
                <li>Off-grid infrastructure maintenance</li>
                <li>Emergency rescue capacity</li>
                <li>Expansion toward 50-state scaling</li>
              </ul>
              <p><strong>Join our growing community of monthly supporters!</strong></p>
              <a href="#donate" className="btn btn-primary">Become a Monthly Sponsor</a>
            </div>

            <div className="help-card">
              <div className="help-icon">🌟</div>
              <h3>One-Time Donation</h3>
              <p>
                Every dollar goes directly to sanctuary operations. We reinvest 100% of donations into:
              </p>
              <ul>
                <li>Rescuing animals from euthanasia</li>
                <li>Building sustainable infrastructure (solar, water systems)</li>
                <li>Expanding capacity to take more animals</li>
                <li>Providing human rehabilitation education</li>
              </ul>
              <p><strong>We operate lean and reinvest 100% of donations into life-saving work.</strong></p>
              <a href="#donate" className="btn btn-primary">Make a Donation</a>
            </div>

            <div className="help-card">
              <div className="help-icon">🤝</div>
              <h3>Partner With Us</h3>
              <p>
                Are you a rescue organization, business, or foundation interested in scaling this model?
              </p>
              <p><strong>Partnership opportunities:</strong></p>
              <ul>
                <li>Rescue network collaboration (animal placements)</li>
                <li>Corporate sponsorship (feed suppliers, tech companies, robotics firms)</li>
                <li>Educational partnerships (research, case studies)</li>
                <li>Land/resource donations (expand sanctuary capacity)</li>
              </ul>
              <a href="/contact" className="btn btn-secondary">Contact Us About Partnerships</a>
            </div>

            <div className="help-card">
              <div className="help-icon">📦</div>
              <h3>In-Kind Donations</h3>
              <p>
                Physical goods are always needed:
              </p>
              <ul>
                <li><strong>Animal supplies:</strong> Dog/cat food, medical supplies, bedding</li>
                <li><strong>Infrastructure:</strong> Solar panels, water tanks, building materials</li>
                <li><strong>Technology:</strong> Computers, tablets, cameras (for documentation)</li>
                <li><strong>Vehicles:</strong> Trucks for transporting animals/supplies</li>
              </ul>
              <a href="/contact" className="btn btn-secondary">Inquire About In-Kind Donations</a>
            </div>

            <div className="help-card">
              <div className="help-icon">📢</div>
              <h3>Spread the Word</h3>
              <p>
                Word-of-mouth has kept us at capacity for a year. Help us reach more people:
              </p>
              <ul>
                <li>Share our story on social media</li>
                <li>Tell rescue organizations about our 100% success rate</li>
                <li>Connect us with potential sponsors or partners</li>
                <li>Write about our work (media, blogs, podcasts)</li>
              </ul>
              <p><strong>Every share saves lives.</strong></p>
            </div>

            <div className="help-card">
              <div className="help-icon">🧡</div>
              <h3>Volunteer (Future)</h3>
              <p>
                We're currently a solo operation (Mary + 4 kids), but as we scale, we'll need:
              </p>
              <ul>
                <li>Animal care volunteers</li>
                <li>Off-grid living educators</li>
                <li>Construction/infrastructure help</li>
                <li>Administrative support</li>
              </ul>
              <p><em>Volunteer program coming soon as we expand capacity.</em></p>
            </div>
          </div>
        </div>
      </section>

      <section className="donate-section" id="donate">
        <div className="container">
          <h2>Make a Donation</h2>
          <p>Your support directly funds life-saving work. We are a registered 501(c)(3) nonprofit. All donations are tax-deductible.</p>
          
          <div className="donate-options">
            <div className="donate-option">
              <h3>PayPal</h3>
              <p>Send donations to: <strong>sabbathpreservationmovement@gmail.com</strong></p>
              <a href="https://www.paypal.com/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Donate via PayPal</a>
            </div>
            <div className="donate-option">
              <h3>Stripe (Coming Soon)</h3>
              <p>Credit card donations will be available soon via Stripe integration.</p>
            </div>
            <div className="donate-option">
              <h3>Mail a Check</h3>
              <p>
                Sabbath Preservation Movement<br/>
                5481 Caves Hwy<br/>
                Cave Junction, OR 97523
              </p>
            </div>
          </div>
          
          <p className="donate-note"><em>We operate transparently. 100% of donations go directly to sanctuary operations.</em></p>
        </div>
      </section>

      <section className="impact-section">
        <div className="container">
          <h2>What Your Donation Provides</h2>
          <div className="impact-grid">
            <div className="impact-item">
              <h4>$50</h4>
              <p>Feeds 10 dogs for one week</p>
            </div>
            <div className="impact-item">
              <h4>$100</h4>
              <p>Emergency veterinary care for one animal</p>
            </div>
            <div className="impact-item">
              <h4>$300</h4>
              <p>Supports monthly operations</p>
            </div>
            <div className="impact-item">
              <h4>$1,000</h4>
              <p>Solar panel expansion for energy independence</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Every Contribution Matters</h2>
          <p>We've proven that love-based rehabilitation works. Now we need help to scale it nationwide. Together, we can create a world where no animal is euthanized for lack of capacity, and no human is abandoned for lack of resources.</p>
          <a href="#donate" className="btn btn-primary btn-large">Support Our Mission Today</a>
        </div>
      </section>
    </div>
  );
}